import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SecondaryButton } from "@/components/shared/ui";

export const TenantShell = ({ agency, children }) => (
  <div className="min-h-screen bg-panel text-sm text-foreground">
    <header className="border-b bg-background">
      <div className="mx-auto flex h-14 max-w-md items-center justify-between px-5 md:max-w-5xl md:px-8">
        <Logo />
        {agency && <span className="truncate pl-4 text-xs text-muted-foreground" data-testid="tenant-agency">{agency}</span>}
      </div>
    </header>
    <main className="mx-auto max-w-md px-5 pb-6 pt-6 md:max-w-5xl md:px-8 md:pb-16 md:pt-10">{children}</main>
  </div>
);

export const TenantLoading = () => <div className="flex justify-center py-24"><Loader2 className="size-6 animate-spin text-muted-foreground" /></div>;

export const TenantLoadError = ({ error, onRetry, testid }) => (
  <div className="flex flex-col items-start gap-3 rounded-xl bg-destructive/10 p-4 text-destructive" data-testid={testid}>
    <p className="text-base">{error}</p>
    <SecondaryButton onClick={onRetry} testid={`${testid}-retry`}>Try again</SecondaryButton>
  </div>
);

export const InlineError = ({ children, testid }) => (
  <div className="mb-4 rounded-lg bg-destructive/10 p-3 text-sm text-destructive" data-testid={testid}>{children}</div>
);
